import { writable } from 'svelte/store';
import { produce } from 'immer';
import { addChanges } from './Changes';

let options = {
  xStepDistance: 8,
  yStepDistance: 8,
  showTreadleOrder: true,
  showThreading: true,

  /*
  showBorders: true,
  tieupLocation: 'bottom-right',
  threadingLocation: 'bottom',
  treadleOrderFirstTreadle: 'right',

  threadingFirstShaft: 'top',
  shedDirection: 'lowering',
  */
};

if (window.localStorage.getItem('options')) {
  let storedUI = JSON.parse(localStorage.getItem('options'));
  options = { ...options, ...storedUI };
}

const store = writable(options);
let prevStore = options;
store.subscribe((s) => {
  prevStore = s;
});

export default {
  options: store,
  update: function (func) {
    store.set(produce(prevStore, func, (patches) => addChanges(patches)));
  },
  subscribe: function (subscription) {
    return store.subscribe(subscription);
  },
};

window.dropOptions = function () {
  localStorage.removeItem('options');
};

store.subscribe((value) => {
  window.options = value;
  localStorage.setItem('options', JSON.stringify({}));
});
